import React, { useEffect, useState } from 'react';
import { Avatar, Box, Button, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useAuth } from '../../hooks/useAuth';
import { makeStyles } from '@mui/styles';
import { CssTextField } from '../layout/elements';
import { NotificationManager } from 'react-notifications';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import DraftsIcon from '@mui/icons-material/Drafts';
import { getSiteSetting, setSiteSetting, updateSiteSetting } from '../../services/user-services';
// import { useLocation } from 'react-router-dom';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import HomeIcon from '@mui/icons-material/Home';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useFetchSetting } from '../../hooks/fetchs-site';
import ProgressWait from './progress';
import SelectLang from '../materials/mat_lang-select';
import AttributionIcon from '@mui/icons-material/Attribution';
import { grey } from '@mui/material/colors';


const useStyles = makeStyles( theme => ({
    header_dtl: {
        fontFamily: 'Segoe UI',
        marginRight: '10px',
        marginTop: '10px',
        color: theme.mainAccentColor
    },
    memberContainer:{
      display: 'grid',
      gridTemplateColumns: '100px auto'
    },
    image_cover:{
        height:500, 
        width:'100%', 
        paddingLeft: '-2rem',
        paddingRight: '-1rem',
    }
}))

function findLagSiteSetting(array, id) {
    if(array){
        return array.find((element) => {
            return element.lang === id
        })
    }
    return array
}

function SiteSetting() {
    
    const { authData, authDataLang } = useAuth()
    // const { id } = useParams()
    const [ data, loading, error ] = useFetchSetting(authData.token, authDataLang?.id)
    const [isAdmin, setIsAdmin] = useState(false)
    const [mySetting, setMySetting] = useState('')
    const [waiting, setWaiting] = useState('')

    // const location = useLocation()
    // const { state } = location
    const [statusReq, setStatusReq ] = useState(false)
    const [loadingLang, setLoadingLang ] = useState(false)
    // const [errorLang, setErrorLang ] = useState(false)
    const [ siteId, setSiteId ] = useState(0)

    const [ image, setImage ] = useState('')
    const [ imageLogo, setImageLogo ] = useState('')
    const [ imageSelect, setImageSelect ] = useState('')
    const [ imageLogoSelect, setImageLogoSelect ] = useState('')
    const [altImage, setAltImage ] = useState('')
    const [altImageLogo, setAltImageLogo ] = useState('')
    const [mainHeader, setMainHeader ] = useState('')
    const [email, setEmail ] = useState('')
    const [address, setAddress ] = useState('')
    const [phoneNumber, setPhoneNumber ] = useState('')
    const [siteName, setSiteName ] = useState('')
    const [linkInstagram, setLinkInstagram ] = useState('')
    const [linkTwiter, setLinkTwiter ] = useState('')
    const [linkTelegram, setLinkTelegram ] = useState('')
    const [linkWhatsapp, setLinkWhatsapp ] = useState('')
    const [linkFacebook, setLinkFacebook ] = useState('')
    const [aboatMe, setAboatMe ] = useState('')
    const [matLang, setMatLang ] = useState({})
    ////////////////////////////////////////////
    const [descAboatMe, setDescAboatMe ] = useState('')
    const [descCallMe, setDescCallMe ] = useState('')
    const [descFollowMe, setDescFollowMe ] = useState('')
    const [descSearch, setDescSearch ] = useState('')
    const [descNewGroup, setDescNewGroup ] = useState('')
    const [descMenuNewMat, setDescMenuNewMat ] = useState('')
    const [descMenuNewBuy, setDescMenuNewBuy ] = useState('')
    const [descMenuProfile, setDescMenuProfile ] = useState('')
    const [descMenuSetting, setDescMenuSetting ] = useState('')
    const [descMenuLogout, setDescMenuLogout ] = useState('')
    const [descMenuLogin, setDescMenuLogin ] = useState('')
    const [descMenuReport, setDescMenuReport ] = useState('')
    const [descMsg, setDescMsg ] = useState('')
    const [descMsgSend, setDescMsgSend ] = useState('')
    const [descHearder, setDescHearder ] = useState('')
    const [descDescripton, setDescDescripton ] = useState('')
    
    const [descAccount, setDescAccount ] = useState('')
    const [descAccountLogin, setDescAccountLogin ] = useState('')
    const [descFee, setDescFee ] = useState('')
    const [descFeeCall, setDescFeeCall ] = useState('')
    const [descReqAsk, setDescReqAsk ] = useState('')
    const [descComments, setDescComments ] = useState('')
    const [descComment, setDescComment ] = useState('')
    
    const [descRegister, setDescRegister ] = useState('')
    const [descUsername, setDescUsername ] = useState('')
    const [descPassword, setDescPassword ] = useState('')
    const [descRepPassword, setDescRepPassword ] = useState('')
    const [descForgetPassword, setDescForgetPassword ] = useState('')
    const [descFamili, setDescFamili ] = useState('')
    const [descEmail, setDescEmail ] = useState('')
    const [descPhone, setDescPhone ] = useState('')
    const [descAddress, setDescAddress ] = useState('')
    const [descBntOK, setDescBntOK ] = useState('')
    const [descPassError, setDescPassError ] = useState('')
    const [descUseUsername, setDescUseUsername ] = useState('')

    const cssClass = useStyles()
    
    useEffect(() => {
        window.scrollTo(0, 0)
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        setMySetting(data)
        if(data){
            setStatusReq(true)
            // if (data.id){
            //     setSiteId(data.id)
            // }
            
            if (data?.lang){
                setMatLang(data.lang)
            }
            
            if (data.image_alt){
                setAltImage(data.image_alt)
            }
            if (data.image_logo_alt){
                setAltImageLogo(data.image_logo_alt)
            }
            if (data.title){
                setMainHeader(data.title)
            }
            if (data.site_email){
                setEmail(data.site_email)
            }
            if (data.site_address){
                setAddress(data.site_address)
            }
            if (data.image){
                setImage(data.image)
            }
            if (data.image_logo){
                setImageLogo(data.image_logo)
            }
            if (data.site_phone){
                setPhoneNumber(data.site_phone)
            }
            if (data.site_name){
                setSiteName(data.site_name)
            }
            if (data.instagram_link){
                setLinkInstagram(data.instagram_link)
            }
            if (data.twitter_link){
                setLinkTwiter(data.twitter_link)
            }
            if (data.telegram_link){
                setLinkTelegram(data.telegram_link)
            }
            if (data.whatsapp_link){
                setLinkWhatsapp(data.whatsapp_link)
            }
            if (data.facebook_link){
                setLinkFacebook(data.facebook_link)
            }
            if (data.about_me){
                setAboatMe(data.about_me)
            }
        }
        
    }, [data, setMySetting])


    const handleSelectLang = (value) => {
        // console.log(value)
        setMatLang(value)
        setSiteId(0)
        setAltImage('')
        setAltImageLogo('')
        setMainHeader('')
        setEmail('')
        setAddress('')
        setImage(null)
        setImageLogo(null)
        setImageSelect(null)
        setImageLogoSelect(null)
        setPhoneNumber('')
        setSiteName('')
        setLinkInstagram('')
        setLinkTwiter('')
        setLinkTelegram('')
        setLinkWhatsapp('')
        setLinkFacebook('')
        setAboatMe('')

        setDescAboatMe('')
        setDescFollowMe('')
        setDescCallMe('')
        setDescSearch('')
        setDescMenuLogin('')
        setDescMenuLogout('')
        setDescMenuNewBuy('')
        setDescMenuNewMat('')
        setDescMenuProfile('')
        setDescMenuReport('')
        setDescMenuSetting('')
        setDescMsg('')
        setDescMsgSend('')
        setDescHearder('')
        setDescNewGroup('')
        setDescDescripton('')
        
        setDescAccount('')
        setDescAccountLogin('')
        setDescFee('')
        setDescFeeCall('')
        setDescReqAsk('')
        setDescComments('')
        setDescComment('')

        setDescRegister('')
        setDescUsername('')
        setDescPassword('')
        setDescRepPassword('')
        setDescForgetPassword('')
        setDescFamili('')
        setDescEmail('')
        setDescPhone('')
        setDescAddress('')
        setDescBntOK('')
        setDescPassError('')
        setDescUseUsername('')

        setLoadingLang(true)
        const getData = async() =>{
            await getSiteSetting(value.id)
            .then(data => {
                // console.log('list site:', findLagSiteSetting(data, value.id))
                let siteSetting = findLagSiteSetting(data, value.id)
                setMySetting(siteSetting)
                if(siteSetting){
                    // console.log(siteSetting)
                    setStatusReq(true)

                    if (siteSetting?.lang){
                        setMatLang(siteSetting.lang)
                    }
                    if (siteSetting?.id){
                        setSiteId(siteSetting.id)
                    }
                    if (siteSetting?.image_alt){
                        setAltImage(siteSetting.image_alt)
                    }
                    if (siteSetting?.image_logo_alt){
                        setAltImageLogo(siteSetting.image_logo_alt)
                    }
                    if (siteSetting?.title){
                        setMainHeader(siteSetting.title)
                    }
                    if (siteSetting?.site_email){
                        setEmail(siteSetting.site_email)
                    }
                    if (siteSetting?.site_address){
                        setAddress(siteSetting.site_address)
                    }
                    if (siteSetting?.image){
                        setImage(siteSetting.image)
                    }
                    if (siteSetting?.image_logo){
                        setImageLogo(siteSetting.image_logo)
                    }
                    if (siteSetting?.site_phone){
                        setPhoneNumber(siteSetting.site_phone)
                    }
                    if (siteSetting?.site_name){
                        setSiteName(siteSetting.site_name)
                    }
                    if (siteSetting?.instagram_link){
                        setLinkInstagram(siteSetting.instagram_link)
                    }
                    if (siteSetting?.twitter_link){
                        setLinkTwiter(siteSetting.twitter_link)
                    }
                    if (siteSetting?.telegram_link){
                        setLinkTelegram(siteSetting.telegram_link)
                    }
                    if (siteSetting?.whatsapp_link){
                        setLinkWhatsapp(siteSetting.whatsapp_link)
                    }
                    if (siteSetting?.facebook_link){
                        setLinkFacebook(siteSetting.facebook_link)
                    }
                    if (siteSetting?.about_me){
                        setAboatMe(siteSetting.about_me)
                    }
                    ////////////////////////////////////
                    if (siteSetting?.desc_about_me){
                        setDescAboatMe(siteSetting.desc_about_me)
                    }
                    if (siteSetting?.desc_call_me){
                        setDescCallMe(siteSetting.desc_call_me)
                    }
                    if (siteSetting?.desc_follow_me){
                        setDescFollowMe(siteSetting.desc_follow_me)
                    }
                    if (siteSetting?.desc_search){
                        setDescSearch(siteSetting.desc_search)
                    }
                    if (siteSetting?.desc_new_group){
                        setDescNewGroup(siteSetting.desc_new_group)
                    }
                    if (siteSetting?.desc_menu_profile){
                        setDescMenuProfile(siteSetting.desc_menu_profile)
                    }
                    if (siteSetting?.desc_menu_new_material){
                        setDescMenuNewMat(siteSetting.desc_menu_new_material)
                    }
                    if (siteSetting?.desc_menu_new_buy){
                        setDescMenuNewBuy(siteSetting.desc_menu_new_buy)
                    }
                    if (siteSetting?.desc_menu_setting){
                        setDescMenuSetting(siteSetting.desc_menu_setting)
                    }
                    if (siteSetting?.desc_menu_exit){
                        setDescMenuLogout(siteSetting.desc_menu_exit)
                    }
                    if (siteSetting?.desc_menu_login){
                        setDescMenuLogin(siteSetting.desc_menu_login)
                    }
                    if (siteSetting?.desc_menu_report){
                        setDescMenuReport(siteSetting.desc_menu_report)
                    }
                    if (siteSetting?.desc_menu_msg){
                        setDescMsg(siteSetting.desc_menu_msg)
                    }
                    if (siteSetting?.desc_menu_msg_send){
                        setDescMsgSend(siteSetting.desc_menu_msg_send)
                    }
                    if (siteSetting?.desc_header){
                        setDescHearder(siteSetting.desc_header)
                    }
                    if (siteSetting?.desc_description){
                        setDescDescripton(siteSetting.desc_description)
                    }
                    if (siteSetting?.desc_account){
                        setDescAccount(siteSetting.desc_account)
                    }
                    if (siteSetting?.desc_account_login){
                        setDescAccountLogin(siteSetting.desc_account_login)
                    }
                    if (siteSetting?.desc_fee){
                        setDescFee(siteSetting.desc_fee)
                    }
                    if (siteSetting?.desc_fee_call){
                        setDescFeeCall(siteSetting.desc_fee_call)
                    }
                    if (siteSetting?.desc_req_ask){
                        setDescReqAsk(siteSetting.desc_req_ask)
                    }
                    if (siteSetting?.desc_comments){
                        setDescComments(siteSetting.desc_comments)
                    }
                    if (siteSetting?.desc_comment){
                        setDescComment(siteSetting.desc_comment)
                    }
                    if (siteSetting?.desc_register){
                        setDescRegister(siteSetting.desc_register)
                    }
                    if (siteSetting?.desc_user_name){
                        setDescUsername(siteSetting.desc_user_name)
                    }
                    if (siteSetting?.desc_password){
                        setDescPassword(siteSetting.desc_password)
                    }
                    if (siteSetting?.desc_rep_password){
                        setDescRepPassword(siteSetting.desc_rep_password)
                    }
                    if (siteSetting?.desc_forget_password){
                        setDescForgetPassword(siteSetting.desc_forget_password)
                    }
                    if (siteSetting?.desc_famili){
                        setDescFamili(siteSetting.desc_famili)
                    }
                    if (siteSetting?.desc_email){
                        setDescEmail(siteSetting.desc_email)
                    }
                    if (siteSetting?.desc_phone){
                        setDescPhone(siteSetting.desc_phone)
                    }
                    if (siteSetting?.desc_address){
                        setDescAddress(siteSetting.desc_address)
                    }
                    if (siteSetting?.desc_buttom_accept){
                        setDescBntOK(siteSetting.desc_buttom_accept)
                    }
                    if (siteSetting?.desc_msg_wrong_pass){
                        setDescPassError(siteSetting.desc_msg_wrong_pass)
                    }
                    if (siteSetting?.desc_msg_use_username){
                        setDescUseUsername(siteSetting.desc_msg_use_username)
                    }
                }    
                setLoadingLang(false)
                // setErrorLang(false)
            }).catch( (e) => {
                // setErrorLang(true)
                setLoadingLang(false)
            })
        }
        getData()        
    }


    const onSelectFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            setImageSelect(undefined)
            return
        }

        // setImage(e.target.files[0])
        // I've kept this example simple by using the first image instead of multiple
        setImageSelect(e.target.files[0])
        // console.log(e.target.files[0])
        setImage(URL.createObjectURL(e.target.files[0]))
    }

    const onSelectFileLogo = e => {
        // console.log('logo', e.target.files)
        if (!e.target.files || e.target.files.length === 0) {
            setImageLogoSelect(undefined)
            return
        }

        // setImage(e.target.files[0])
        // I've kept this example simple by using the first image instead of multiple
        setImageLogoSelect(e.target.files[0])
        // console.log(e.target.files[0])
        setImageLogo(URL.createObjectURL(e.target.files[0]))
    }

    const handelSubmit = async e => {
        e.preventDefault()
        setWaiting(true)
        const uploaddata = new FormData()
        if(imageSelect){
            uploaddata.append('image', imageSelect, imageSelect.name)
        }
        if(imageLogoSelect){
            uploaddata.append('image_logo', imageLogoSelect, imageLogoSelect.name)
        }
        // console.log(matLang)
        // if(siteId){
        //     uploaddata.append('id', siteId)
        // }
        if(matLang){
            uploaddata.append('lang', matLang)
        }
        if(mainHeader){
            uploaddata.append('title', mainHeader)
        }
        if(altImage){
            uploaddata.append('image_alt', altImage)
        }
        if(altImageLogo){
            uploaddata.append('image_logo_alt', altImageLogo)
        }
        if(email){
            uploaddata.append('site_email', email)
        }
        if(address){
            uploaddata.append('site_address', address)
        }
        if(phoneNumber){
            uploaddata.append('site_phone', phoneNumber)
        }
        if(siteName){
            uploaddata.append('site_name', siteName)
        }
        if(linkInstagram){
            uploaddata.append('instagram_link', linkInstagram)
        }
        if(linkTwiter){
            uploaddata.append('twitter_link', linkTwiter)
        }
        if(linkTelegram){
            uploaddata.append('telegram_link', linkTelegram)
        }
        if(linkWhatsapp){
            uploaddata.append('whatsapp_link', linkWhatsapp)
        }
        if(linkFacebook){
            uploaddata.append('facebook_link', linkFacebook)
        }
        if(aboatMe){
            uploaddata.append('about_me', aboatMe)
        }
        if(descAboatMe){
            uploaddata.append('desc_about_me', descAboatMe)
        }
        if(descCallMe){
            uploaddata.append('desc_call_me', descCallMe)
        }
        if(descFollowMe){
            uploaddata.append('desc_follow_me', descFollowMe)
        }
        if(descSearch){
            uploaddata.append('desc_search', descSearch)
        }
        if(descNewGroup){
            uploaddata.append('desc_new_group', descNewGroup)
        }
        if(descMenuProfile){
            uploaddata.append('desc_menu_profile', descMenuProfile)
        }
        if(descMenuNewMat){
            uploaddata.append('desc_menu_new_material', descMenuNewMat)
        }
        if(descMenuNewBuy){
            uploaddata.append('desc_menu_new_buy', descMenuNewBuy)
        }
        if(descMenuSetting){
            uploaddata.append('desc_menu_setting', descMenuSetting)
        }
        if(descMenuLogout){
            uploaddata.append('desc_menu_exit', descMenuLogout)
        }
        if(descMenuLogin){
            uploaddata.append('desc_menu_login', descMenuLogin)
        }
        if(descMenuReport){
            uploaddata.append('desc_menu_report', descMenuReport)
        }
        if(descMsg){
            uploaddata.append('desc_menu_msg', descMsg)
        }
        if(descMsgSend){
            uploaddata.append('desc_menu_msg_send', descMsgSend)
        }
        if(descHearder){
            uploaddata.append('desc_header', descHearder)
        }
        if(descDescripton){
            uploaddata.append('desc_description', descDescripton)
        }
        if(descAccount){
            uploaddata.append('desc_account', descAccount)
        }
        if(descAccountLogin){
            uploaddata.append('desc_account_login', descAccountLogin)
        }
        if(descFee){
            uploaddata.append('desc_fee', descFee)
        }
        if(descFeeCall){
            uploaddata.append('desc_fee_call', descFeeCall)
        }
        if(descReqAsk){
            uploaddata.append('desc_req_ask', descReqAsk)
        }
        if(descComments){
            uploaddata.append('desc_comments', descComments)
        }
        if(descComment){
            uploaddata.append('desc_comment', descComment)
        }
        if(descRegister){
            uploaddata.append('desc_register', descRegister)
        }
        if(descUsername){
            uploaddata.append('desc_user_name', descUsername)
        }
        if(descPassword){
            uploaddata.append('desc_password', descPassword)
        }
        if(descRepPassword){
            uploaddata.append('desc_rep_password', descRepPassword)
        }
        if(descForgetPassword){
            uploaddata.append('desc_forget_password', descForgetPassword)
        }
        if(descFamili){
            uploaddata.append('desc_famili', descFamili)
        }
        if(descEmail){
            uploaddata.append('desc_email', descEmail)
        }
        if(descPhone){
            uploaddata.append('desc_phone', descPhone)
        }
        if(descAddress){
            uploaddata.append('desc_address', descAddress)
        }
        if(descBntOK){
            uploaddata.append('desc_buttom_accept', descBntOK)
        }
        if(descPassError){
            uploaddata.append('desc_msg_wrong_pass', descPassError)
        }
        if(descUseUsername){
            uploaddata.append('desc_msg_use_username', descUseUsername)
        }
        
        
        if(statusReq){
            const siteSetting = await updateSiteSetting(authData?.token, siteId, uploaddata, matLang)
            // console.log(siteSetting)
            if (siteSetting){
                NotificationManager.success('تنظیمات سایت بروز شد')
            }else{
                NotificationManager.error('متاسفانه خطایی در زمان تنظیمات سایت وجود دارد')
            }
        }else{
            const siteSetting = await setSiteSetting(authData?.token, uploaddata)
            // console.log(siteSetting)
            if (siteSetting){
                NotificationManager.success('تنظیمات سایت به برنامه اضافه شد')
            }else{
                NotificationManager.error('متاسفانه خطایی در زمان ثبت تنظیمات سایت وجود دارد')
            }
        }
        setWaiting(false)
    }
    
    if (waiting) return <ProgressWait statusWait={true}/> 

  return (
    <React.Fragment>
        {isAdmin ?
            <div style={{minHeight: 1000}}  dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
                <div style={{display: 'grid', gridTemplateColumns: '1fr 10rem'}}>
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h2"
                        >
                        اطلاعات سایت
                    </Typography>
                </div>        
                <Divider />
                <br/>
                <Grid container spacing={1} alignItems='flex-end'>
                    <Grid item>
                        <ViewInArIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item >
                        <SelectLang
                            onChange={handleSelectLang} 
                            selectedValue={matLang} />
                    </Grid>
                    <Grid item>
                        *
                    </Grid>
                </Grid>
                <br/>
                <Divider />
                <br/>
                    <Paper elevation={3} sx={{
                            display: 'block',
                            marginRight: 'auto',
                            marginLeft: 'auto',
                            textAlign: 'right',
                        }} >

                        <form onSubmit={handelSubmit}>
                            <div style={{textAlign: 'right', marginRight: 20}}>
                                <Box sx={{  display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                                    <div>
                                        <Grid container spacing={1} alignItems='flex-end'>
                                            <Grid item>
                                                <div>عکس</div>
                                            </Grid>
                                            <Grid item>
                                                <input
                                                    accept="image/*"
                                                    style={{ display: 'none', width: '100%', height: '100%' }}
                                                    id="raised-button-file"
                                                    multiple
                                                    type="file"
                                                    onChange={onSelectFile}
                                                />
                                                <label htmlFor="raised-button-file">
                                                    <Button variant="raised" component="span" >
                                                        <Avatar sx={{width: '200px', height: '100px'}}
                                                            src={image} />
                                                    </Button>
                                                </label>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1} alignItems='flex-end'>
                                            <Grid item>
                                                <AttributionIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CssTextField 
                                                    label={(
                                                        <Typography
                                                            fontFamily='b_mitra' 
                                                            component="div"
                                                            variant="h6"
                                                            color={grey[500]}
                                                            >
                                                            نام عکس (Image Alt)
                                                        </Typography>
                                                    )}
                                                    fullWidth
                                                    variant="standard" value={altImage}
                                                    onChange={ e => setAltImage( e.target.value )} />
                                            </Grid>
                                        </Grid>
                                    </div>
                                    <div>
                                        <Grid container spacing={1} alignItems='flex-end'>
                                            <Grid item>
                                                <div>لوگو</div>
                                            </Grid>
                                            <Grid item>
                                                <input
                                                    accept="image/*"
                                                    style={{ display: 'none', width: '100%', height: '100%' }}
                                                    id="raised-logo-file"
                                                    multiple
                                                    type="file"
                                                    onChange={onSelectFileLogo}
                                                />
                                                <label htmlFor="raised-logo-file">
                                                    <Button variant="raised" component="span" >
                                                        <Avatar sx={{width: '200px', height: '100px'}}
                                                            src={imageLogo} />
                                                    </Button>
                                                </label>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1} alignItems='flex-end'>
                                            <Grid item>
                                                <AttributionIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CssTextField 
                                                    label={(
                                                        <Typography
                                                            fontFamily='b_mitra' 
                                                            component="div"
                                                            variant="h6"
                                                            color={grey[500]}
                                                            >
                                                            نام لوگو عکس (Logo Alt)
                                                        </Typography>
                                                    )}
                                                    fullWidth
                                                    variant="standard" value={altImageLogo}
                                                    onChange={ e => setAltImageLogo( e.target.value )} />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Box>
                                <br/>
                                <Divider />
                                <br/>

                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <ViewInArIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر اصلی سایت
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard" value={mainHeader}
                                            onChange={ e => setMainHeader( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <AlternateEmailIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    ایمیل
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard" value={email}
                                            onChange={ e => setEmail( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <DraftsIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    آدرس
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard" value={address}
                                            onChange={ e => setAddress( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <PhoneInTalkIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    تلفن
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={phoneNumber}
                                            onChange={ e => setPhoneNumber( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <HomeIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    نام سایت
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={siteName}
                                            onChange={ e => setSiteName( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <InstagramIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    لینک (Instagram)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={linkInstagram}
                                            onChange={ e => setLinkInstagram( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <TwitterIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    لینک (twitter)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={linkTwiter}
                                            onChange={ e => setLinkTwiter( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <TelegramIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    لینک (telegram)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={linkTelegram}
                                            onChange={ e => setLinkTelegram( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <WhatsAppIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    لینک (whatsapp)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={linkWhatsapp}
                                            onChange={ e => setLinkWhatsapp( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    لینک (facebook)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={linkFacebook}
                                            onChange={ e => setLinkFacebook( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item sx={{marginTop: '1fr', marginBottom: 'auto',}}>
                                        <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    درباره ما (دراینجا توضیح مختصری از فعالیت باید وارد شود)
                                                </Typography>
                                            )}
                                            multiline
                                            fullWidth
                                            rows={4} 
                                            className={cssClass.header_dtl}
                                            variant="standard" value={aboatMe}
                                            onChange={ e => setAboatMe( e.target.value )} />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر درباره ما
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descAboatMe}
                                            onChange={ e => setDescAboatMe( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر تماس با ما
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descCallMe}
                                            onChange={ e => setDescCallMe( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر دنبال کردن ما
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descFollowMe}
                                            onChange={ e => setDescFollowMe( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر جستجو
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descSearch}
                                            onChange={ e => setDescSearch( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر گروه جدید
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descNewGroup}
                                            onChange={ e => setDescNewGroup( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (پروفایل)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMenuProfile}
                                            onChange={ e => setDescMenuProfile( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (اضافه کردن کالا)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMenuNewMat}
                                            onChange={ e => setDescMenuNewMat( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (خرید کالا)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMenuNewBuy}
                                            onChange={ e => setDescMenuNewBuy( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (تنظیمات)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMenuSetting}
                                            onChange={ e => setDescMenuSetting( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (گزارشات)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMenuReport}
                                            onChange={ e => setDescMenuReport( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (خروج)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMenuLogout}
                                            onChange={ e => setDescMenuLogout( e.target.value )} />
                                    </Grid>
                                    <Grid item >
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (ورود)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMenuLogin}
                                            onChange={ e => setDescMenuLogin( e.target.value )} />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (پیام)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMsg}
                                            onChange={ e => setDescMsg( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (ارسال پیام)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descMsgSend}
                                            onChange={ e => setDescMsgSend( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر  (موضوع)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descHearder}
                                            onChange={ e => setDescHearder( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر منو (توضیحات)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descDescripton}
                                            onChange={ e => setDescDescripton( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (حساب)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descAccount}
                                            onChange={ e => setDescAccount( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (وارد حساب کاربری)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descAccountLogin}
                                            onChange={ e => setDescAccountLogin( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (قیمت)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descFee}
                                            onChange={ e => setDescFee( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (قیمت تماس بگیرید)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descFeeCall}
                                            onChange={ e => setDescFeeCall( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (درخواست مشاوره)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descReqAsk}
                                            onChange={ e => setDescReqAsk( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (نظرات را وارد کنید)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descComments}
                                            onChange={ e => setDescComments( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (نظرات و پیشنهادات)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descComment}
                                            onChange={ e => setDescComment( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (ثبت نام )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descRegister}
                                            onChange={ e => setDescRegister( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (نام کاربری )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descUsername}
                                            onChange={ e => setDescUsername( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (رمزعبور )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descPassword}
                                            onChange={ e => setDescPassword( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (تکرار رمزعبور )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descRepPassword}
                                            onChange={ e => setDescRepPassword( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (فراموشی رمزعبور )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descForgetPassword}
                                            onChange={ e => setDescForgetPassword( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (مشخصات )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descFamili}
                                            onChange={ e => setDescFamili( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (ایمیل )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descEmail}
                                            onChange={ e => setDescEmail( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (تلفن )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descPhone}
                                            onChange={ e => setDescPhone( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (آدرس )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descAddress}
                                            onChange={ e => setDescAddress( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (دکمه ثبت )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descBntOK}
                                            onChange={ e => setDescBntOK( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (پیام رمز اشتباه  )
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard"  value={descPassError}
                                            onChange={ e => setDescPassError( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <FacebookIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <CssTextField 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={grey[500]}
                                                    >
                                                    هدر (نام کاربری استفاده شده)
                                                </Typography>
                                            )}
                                            fullWidth
                                            inputProps={{style : {color : grey[900]}}}
                                            variant="standard"  value={descUseUsername}
                                            onChange={ e => setDescUseUsername( e.target.value )} />
                                    </Grid>
                                </Grid>

                                
                            </div>
                            <br />
                            <Divider />
                            <br/>
                                        
                            <Button sx={{fontFamily: 'b_mitra', paddingLeft: 5, paddingRight: 5, margin: 5}} 
                                variant="contained" color="primary" type='submit'
                                disabled={!aboatMe || !linkInstagram || !siteName || !phoneNumber || !address || !email || !mainHeader || !altImage}>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h4"
                                    >
                                    ثبت
                                </Typography>
                            </Button>
                        </form>
                    </Paper>
                {/* </Box> */}
            </div>
        :
        <div>
            صفحه ای وجود ندارد
        </div>
        }
    </React.Fragment>
  )
}

export default SiteSetting
